import { createAsyncThunk } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { hideAddCustomerModal, showAddCustomerModal, submitAddCustomerModal } from './offersSlice'

const addCustomerModalInitialState = {
  addCustomerModal: {
    isOpened: false,
    isSubmitted: false,
    title: 'Add Customer',
    customerName: '',
    BRNo: '',
  },
}

const addCustomerModalReducer = {
  showAddCustomerModal: (state, { payload }) => {
    state.addCustomerModal = {
      isOpened: true,
      isSubmitted: false,
      title: payload?.title || 'Add Customer',
      customerName: payload?.customerName || '',
      BRNo: payload?.BRNo || '',
    }
  },
  submitAddCustomerModal: (state, { payload }) => {
    state.addCustomerModal = {
      isOpened: false,
      isSubmitted: true,
      title: 'Add Customer',
      customerName: payload?.customerName || '',
      BRNo: payload?.BRNo || '',
    }
  },
  hideAddCustomerModal: (state) => {
    state.addCustomerModal = {
      isOpened: false,
      isSubmitted: false,
      customerName: '',
      BRNo: '',
    }
  },
}

const selectAddCustomerModal = (state) => state.offers.addCustomerModal

const addCustomerModalThunkAction = {
  open: createAsyncThunk('offer', async (payload, { extra, dispatch }) => {
    const store = extra.store

    //FIXME: Need a new way to define redux action
    dispatch(showAddCustomerModal(payload))

    return new Promise((resolve) => {
      const unsubscribe = store.subscribe(() => {
        const state = store.getState()
        const { isSubmitted, isOpened, customerName, BRNo } = state.offers.addCustomerModal
        if (isSubmitted) {
          unsubscribe()
          resolve({ isSubmitted: true, customerName, BRNo })
        }

        if (!isOpened) {
          unsubscribe()
          resolve({ isSubmitted: false })
        }
      })
    })
  }),
}

const useAddCustomerModalManagement = () => {
  const dispatch = useDispatch()
  const { isOpened, title, customerName, BRNo } = useSelector((state) => state.offers.addCustomerModal)

  const open = async (arg) => {
    const { payload } = await dispatch(addCustomerModalThunkAction.open(arg))
    return payload
  }
  const submit = ({ customerName, BRNo }) => {
    return dispatch(submitAddCustomerModal({ customerName, BRNo }))
  }
  const close = () => {
    return dispatch(hideAddCustomerModal())
  }
  return {
    isOpened,
    title,
    customerName,
    BRNo,
    open,
    submit,
    close,
  }
}

export { addCustomerModalInitialState, addCustomerModalReducer, selectAddCustomerModal, useAddCustomerModalManagement }
